import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import LinkButton from 'flarum/common/components/LinkButton';
import ContestPage from './components/ContestPage';
import ContestIndexPage from './components/ContestIndexPage';
import ContestCard from './components/ContestCard';
import ContestWizard from './components/ContestWizard';
import ChatPage from './components/ChatPage';

app.initializers.add('happydigital-quiz', () => {
  // Routes are declared server-side via Extend\Frontend->route(), so a direct
  // URL, a refresh and the back button all work; these map them to components.
  app.routes['happyQuiz.index'] = { path: '/yarismalar', component: ContestIndexPage };
  app.routes['happyQuiz.create'] = { path: '/yarisma-olustur', component: ContestWizard };
  app.routes['happyQuiz.edit'] = { path: '/yarisma-duzenle/:id', component: ContestWizard };
  app.routes['happyQuiz.chat'] = { path: '/yarisma/:slug/sohbet', component: ChatPage };
  app.routes['happyQuiz.show'] = { path: '/yarisma/:slug', component: ContestPage };

  // Persistent nav entry. Flarum renders this in the sidebar on desktop and
  // folds it into the existing drawer on mobile, so no separate mobile nav is
  // needed and nothing is forced in front of the user.
  extend(IndexPage.prototype, 'navItems', function (items) {
    items.add(
      'happyQuiz',
      <LinkButton href={app.route('happyQuiz.index')} icon="fas fa-question-circle">
        {app.translator.trans('happydigital-quiz.forum.nav.title')}
      </LinkButton>,
      -10
    );
  });

  // The contest card, above the discussion list.
  extend(IndexPage.prototype, 'contentItems', function (items) {
    if (!app.forum.attribute('happyQuizShowHomeCard')) return;

    items.add('happyQuizCard', <ContestCard />, 110);
  });
});
